/**
 * @desc 监听页面 resize
 * @date 2019-08-29
 * @author Kody
 */
import { useEffect, useState } from 'react';
import { $window } from '@umu/umu-dom';
import { useDebounce } from './useDebounce';

export const useBodyResize = (callback?: (width: number) => void) => {
    const getBody = () => document.body || document.documentElement || { clientWidth: window.innerWidth };
    const [width, setWidth] = useState(getBody().clientWidth);

    const onResize = useDebounce(
        () => {
            const currentWidth = getBody().clientWidth;
            setWidth(currentWidth);
            if (callback) {
                callback(currentWidth);
            }
        },
        500,
        [width]
    );

    useEffect(() => {
        $window.addEventListener('resize', onResize);
        return () => {
            $window.removeEventListener('resize', onResize);
        };
    }, []);

    return width;
};
